import styles from './Cost.module.scss';
import CostIcon from './cost.svg?react';
function Cost({ left, cost, black = false }) {
  return (
    <div
      className={`${styles.cost} ${black ? styles.black : ''}`}
      style={{ left: left ?? 0 }}
    >
      <CostIcon
        style={{
          width: 14,
          height: 14,
          verticalAlign: 'middle',
          display: 'inline',
          marginLeft: 2,
          marginRight: 2,
        }}
      />
      <span className="text-[12px]"> {cost}</span>
    </div>
  );
}
export default Cost;
